export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.a060d85c.worker.js");
}
